module.exports = __webpack_public_path__ + "resources/img/facetec_iframe_full_viewport.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec_iframe_full_viewport.png
// module id = 1393
// module chunks = 0